import { Navigate, Route } from "react-router-dom";


import NavigateToLogin from "./pages/Auth/NavigateToLogin";
// import UpdatePassword from "./pages/Auth/Agency/UpdatePassword";
// import ResetPassword from "./pages/Auth/Agency/ResetPassword.jsx";
import AuthLayout from "./layouts/AuthLayout/AuthLayout";
import ClientLayout from "./layouts/ClientLayout/ClientLayout";
import SMEBackground from "./pages/Client/SMEBackground.jsx";
// import SMEIndustryActivity from "./pages/Client/IndustryActivity.jsx";
// import SMERiskAssessment from "./pages/Client/RiskAssessment.jsx";
import NoLayout from "./shared/Layout/NoLayout.jsx";
import Login from "./shared/Auth/Login.jsx";
import Register from "./shared/Auth/Register.jsx";
import ForgotPasword from "./shared/Auth/ForgotPasword.jsx";
import ClientInnerLayout from "./pages/Client/ClientInnerLayout.jsx";
import ProductDetails from "./pages/Products/ProductDetails.jsx";
import CreateClient from "./pages/Client/CreateClient.jsx";
import SectorDetails from "./pages/Sectors/SectorDetails.jsx";
import CompetitiveRisk from "./pages/Client/Competitive/CompetitiveRisk.jsx";
import ProfileSetting from "./pages/User/ProfileSetting.jsx";
import UserLayout from "./layouts/UserLayout/UserLayout.jsx";
import Profile from "./pages/User/Profile.jsx";
import UserInnerLayout from "./pages/User/UserInnerLayout.jsx";
import ExpertProfile from "./pages/User/ExpertProfile.jsx";
import HomePage from "./shared/Auth/HomePage.jsx";
import EnquiryManagement from "./pages/Client/EnquiryManagement.jsx";
import Admin from "./shared/Auth/Admin.jsx";
import Hero from "./components/Hero.jsx";
import ProtectedRoute from "./pages/Auth/ProtectedRoute.jsx";


export const AuthRoutes = (
  <>
    <Route element={<NoLayout />}>
      {/* <Route path="/" element={<Login />} /> */}

      <Route path="/password/forgot" element={<ForgotPasword />} />
    </Route>
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/admin" element={<Admin />}/>
  </>
);

export const UserRoutes = (
  <Route path="user" element={<UserLayout />}>
    <Route path="" element={<UserInnerLayout />}>
      <Route path="profile" element={<Profile />} />
    </Route>
    <Route path="expertprofile" element={<ProfileSetting />} />
    <Route path="expert-detail-profile" element={<ExpertProfile />} />
    <Route path="expert-profile/:expertId" element={<ExpertProfile />} />

  </Route>
);

export const ClientRoutes = (
  <Route path="client" element={<ClientLayout />}>
    <Route path="" element={<ClientInnerLayout />}>
      <Route path="">
        <Route path="add" element={<CreateClient />} />
      </Route>
      <Route path=":clientId">
        <Route path="analyst-bot" element={<SMEBackground />} />
        <Route path="sme-background" element={<SMEBackground />} />
        <Route path="vision-board" element={<SMEBackground />} />
        <Route path="competitive-risks" element={<CompetitiveRisk />} />
        <Route path="goal-setting" element={<SMEBackground />} />
        <Route path="initiatives-review" element={<SMEBackground />} />
        <Route path="enquiry-management" element={<EnquiryManagement />} />
        <Route path="compliance-calendar" element={<SMEBackground />} />
      </Route>
    </Route>
  </Route>
);

export const SectorRoutes = (
  <Route path="sector" element={<ClientLayout />}>
    <Route path=":sectorId">
      {/* <Route path="details" element={<SectorDetails />} /> */}
      <Route
  path="details"
  element={
    <ProtectedRoute>
      <SectorDetails />
    </ProtectedRoute>
  }
/>
    </Route>
  </Route>
);

export const ProductRoutes = (
  <Route path="products" element={<ClientLayout />}>
    <Route path=":productId">
      <Route path="" element={<ProductDetails />} />
    </Route>
  </Route>
);

export const LoginRoutes = (
  <>
    
    
  <Route path="/home" element={<HomePage />} />
  
  <Route path="/sector/:sectorId" element={<Hero />} />
  
  {/* <Route path="/sector/:sectorId/details" element={<SectorDetails />} /> */}
  
 {/* <Route path="*" element={<Navigate to="/home" replace />} /> */}
 <Route path="*" element={<HomePage />} />


  </>
);

export const NotFoundRoute = (
  <Route path="*" element={<Navigate to="/" replace={true} />} />
  

);
